module.exports = __webpack_public_path__ + "static/media/image-choice-light.918d6c13.svg";